import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, TemplateRef, ViewContainerRef } from '@angular/core';
import { DataService } from '../../../services/data.service';
import { InfotooltipComponent } from '../../../commonUI/infotooltip/infotooltip.component';
import { PackageType } from 'src/app/models/packagetype';
import {
    FormGroup,
    FormBuilder,
    Validators,
    FormControl,
} from '@angular/forms';
import { TemplatePortal } from '@angular/cdk/portal';
import { TransportMode } from 'src/app/models/transportmode';
import { SourceType } from 'src/app/models/sourcetype';
import { FormService } from 'src/app/services/form';
import { MatSnackBar } from '@angular/material';
import { ProposalService } from 'src/app/services/proposal.service';
import { ValidateEffectivityFrom } from 'src/app/commonUI/customValidators/proposaliinfofields.valdiator';
import { MultiSelectItem } from '@tesla/angular2-tesla-common/tesla-common';
import { PartBasicInfo } from 'src/app/models/partbasicinfo';
import { CreateProposalDTO } from 'src/app/models/createproposaldto';
import Helper from 'src/app/core/utility/helper';
import { UnitOfMeasurement } from 'src/app/models/internal/unit-of-measurement';
import { Constants } from 'src/app/core/constants';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { BasePage } from 'src/app/core/basepages/allbasepages';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from 'src/app/app.settings';
import { ReasonsNonSubTestDoc } from '../../../models/reason-nonsubmission-testdoc';
import { ProposalPartOriginPropertyId } from '../../../core/constantEnums';
import { ProposalLocation } from '../../../models/internal/proposal-location';
import { BaseItem } from '../../../models/baseitem';
import { TeslaAutocompleteComponent } from '@tesla/angular2-tesla-common/autocomplete/autocomplete.component';
import { ProposalEffectivityHistory } from 'src/app/models/proposaleffectivityhistory';
import { Overlay, OverlayConfig } from '@angular/cdk/overlay';


@Component({
    selector: 'app-proposalbasicinfo',
    templateUrl: './proposalbasicinfo.component.html',
    styleUrls: ['./proposalbasicinfo.component.scss'],
})
export class ProposalbasicinfoComponent extends BasePage implements OnInit {
    packageTypeId: number;

    constructor(
        private dataService: DataService,
        private fb: FormBuilder,
        private proposalService: ProposalService,
        logger: NGXLogger,
        appSettings: AppSettings,
        public FormService: FormService,
        localstorageService: LocalstorageService,
        public snackbar: MatSnackBar,
        private overlay: Overlay,
        private _viewContainerRef: ViewContainerRef
    ) {
        super(localstorageService, logger, appSettings);
        this.proposalBasicInfoForm = this.fb.group({
            partInfoInProposalForm: this.fb.group({
                globalUOMId: [Constants.IMPERIAL_UOM_ID],
                Length: [null, Validators.compose([Validators.required])],
                Width: [null, Validators.compose([Validators.required])],
                Height: [null, Validators.compose([Validators.required])],
                Weight: [null, Validators.compose([Validators.required])],
                Material: [null, Validators.compose([Validators.required])],
            }),
            packageInfoForm: this.fb.group({
                PackageTypeId: [null],
                TransportModeId: [null],
                EffectiveFrom: [null, [Validators.required]],
                EffectiveTo: [null, [Validators.required]],
                SourceTypeId: [null],
                IsFitForAirShipment: [true, [Validators.required]],
            }),
          manufacturingLocationForm: this.fb.group({
            CountryName: [null, [Validators.required]],
            StateName: [null],
            CityId: [null],
            StateId: [null],
            CountryId: [null],
            CityName: [null, [Validators.required]],
            FullName: [null, [Validators.required]],
            SecondaryProcessingEnabled: [false],
            ManufacturingManualLocation: [false]
          }),
          secondaryProcessingLocationForm: this.fb.group({
            CountryName: [null, [Validators.required]],
            StateName: [null],
            CityName: [null, [Validators.required]],
            FullName: [null, [Validators.required]],
            CityId: [null],
            StateId: [null],
            CountryId: [null],
            SecondaryManualLocation: [false],
          }),
        });
        this.unitOfMeansurementList = Helper.getUnitOfMeansurements();
        /**
         * TMS-15424 Remove ability to backdate proposals
         * Users should not be able to provide an effective start date which is in the past.
         * The earliest Effective start date should be the next day of today.
         */
        this.minEffectiveFromDate = Helper.addDays(new Date(), 1);
        this.searchCityURL = this.appSettings.Packaging2APIUrl + '/externaldata/cities';
    }

    get Length() {
        return this.proposalBasicInfoForm.get('partInfoInProposalForm.Length');
    }
    filteredHistoryEffectiveFrom: ProposalEffectivityHistory[];
    filteredHistoryEffectiveTo: ProposalEffectivityHistory[];
    childControlTooltipText: string = '';
    minEffectiveFromDate: Date;
    globalUOM: UnitOfMeasurement = new UnitOfMeasurement();
    sourceTypeDescriptions: string;
    createProposalDTO: CreateProposalDTO;
    @Input() isUpdateMode = false;
    partNumbers: string[];
    POUomCode: string;
    MultiplePartsSeleced: boolean = false;
    proposalBasicInfoForm: FormGroup;
    @Output() effectiveDatesChanged: EventEmitter<any> = new EventEmitter();
    @Output() private formReady: EventEmitter<FormGroup> =
        new EventEmitter<FormGroup>();
    // @Output() private globalUoMUpdated: EventEmitter<UnitOfMeasurement> = new EventEmitter<UnitOfMeasurement>();
    partInfoInProposalForm: FormGroup;
    packageInfoForm: FormGroup;
    manufacturingLocationForm: FormGroup;
    secondaryProcessingLocationForm: FormGroup;
    isCriticalPart: boolean;
    partinfoList: PartBasicInfo[] = [];
    manualManufacturingLocation = false;
    onManufacturingLocationEnabled() {
      this.manualManufacturingLocation = !this.manualManufacturingLocation;
    }
    secondaryProcessingLocationEnabled = false;
    onSecondaryProcessingLocationEnabled(){
      this.secondaryProcessingLocationEnabled = !this.secondaryProcessingLocationEnabled;
    }
    manualSecondaryProcessingLocation = false;
    onManualSecondaryProcessingLocationEnabled() {
      this.manualSecondaryProcessingLocation = !this.manualSecondaryProcessingLocation;
    }
    public packageTypeList: PackageType[];
    public transportModeList: TransportMode[];
    public sourceTypeList: SourceType[];
    selectedSourceTypes: MultiSelectItem[] = [];
    unitOfMeansurementList: UnitOfMeasurement[] = [];
    // public partNumbers: string;
    public formErrorsPartInfoInProposal = {
        Length: '',
        Width: '',
        Height: '',
        Weight: '',
        Material: '',
    };
    public formErrorsProposalInfo = {
        PackageTypeId: '',
        TransportModeId: '',
        EffectiveFrom: '',
        EffectiveTo: '',
        SourceTypeIds: '',

    };

    public formErrorsManufacturingLocation = {
      CityName: '',
      CountryName: '',
      FullName: '',
    };

    public formErrorsSecondaryProcessingLocation = {
      CityName: '',
      CountryName: '',
      FullName: '',
    };

    dimensionsAndWeightsForSaving = {
        Length: null,
        Width: null,
        Height: null,
        Weight: null,
    };
    @Output() tabChangeRequested = new EventEmitter<number>();
    @Output() formUpdated = new EventEmitter<number>();

    get;

    manufacturingLocation: ProposalLocation = new ProposalLocation();
    secondaryProcessingLocation: ProposalLocation = new ProposalLocation();

    public   ProposalPartOriginPropertyId = ProposalPartOriginPropertyId;
    myFilter = (d: Date): boolean => {
        const day = d.getDay();
        // Prevent Saturday and Sunday from being selected.
        return day !== 0 && day !== 6;
    };

    @ViewChild('effectiveFromTemplate') effectiveFromPortalContent: TemplateRef<any>;
    @ViewChild('effectiveToTemplate') effectiveToPortalContent: TemplateRef<any>;
    overlayRef: any;
    selectedPortal: TemplatePortal<any>;
    openOverlay($event, field: string) {
        const positionStrategy = this.overlay.position()
        .flexibleConnectedTo($event.target)
        .withPositions([
          {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top',
          },
           {
            originX: 'start',
            originY: 'top',
            overlayX: 'start',
            overlayY: 'bottom',
          },
        ]);

         const config = new OverlayConfig({
            positionStrategy: positionStrategy,
            height: '100px',
            width: '600px',
            hasBackdrop: false,
        });
        if(field == 'EffectiveTo') {
            if(this.filteredHistoryEffectiveTo && !this.filteredHistoryEffectiveTo.length) return;
            this.selectedPortal = new TemplatePortal(this.effectiveToPortalContent, this._viewContainerRef);
        } else {
            if(this.filteredHistoryEffectiveFrom && !this.filteredHistoryEffectiveFrom.length) return;
            this.selectedPortal = new TemplatePortal(this.effectiveFromPortalContent, this._viewContainerRef);
        }
        this.overlayRef = this.overlay.create(config);
        this.overlayRef.attach(this.selectedPortal);
    }

    closeOverlay(field) {
        if(this.overlayRef) {
            this.overlayRef.dispose();
        }
    }

    ngOnInit() {

        var dateMaxValue = new Date('9999-12-31');
        var browserOffset  = dateMaxValue.getTimezoneOffset();
        dateMaxValue = new Date(dateMaxValue.setMinutes(+ browserOffset));

        this.proposalBasicInfoForm.controls["packageInfoForm"].patchValue({ 
            EffectiveFrom: new Date(),
            EffectiveTo: dateMaxValue
        });

        this.createProposalDTO = new CreateProposalDTO();
        this.proposalService.proposalEstimate.subscribe((estimate) => {
            if (estimate && !this.isUpdateMode) {
                this.createProposalDTO.EstimateProposal = estimate;
                // this.createProposalDTO.DefaultProposal.PartInfo.Length = primaryPackageLevelEstimate.PartLength as number;
                // this.createProposalDTO.DefaultProposal.PartInfo.Width = primaryPackageLevelEstimate.PartWidth as number;
                // this.createProposalDTO.DefaultProposal.PartInfo.Height = primaryPackageLevelEstimate.PartHeight as number;
                // this.createProposalDTO.DefaultProposal.PartInfo.Weight = primaryPackageLevelEstimate.PartWeight as number;
                let primaryPackageLevelEstimate = estimate.find(
                    (x) => x.PackageLevelId == 1
                );

                this.createProposalDTO.DefaultProposal.PackageInfo.PackageTypeId =
                    primaryPackageLevelEstimate.PackageTypeId as number;
                this.packageTypeId = this.createProposalDTO.DefaultProposal.PackageInfo.PackageTypeId;
                this.proposalService.RefreshPackageTypeDescription(
                    primaryPackageLevelEstimate.PackageTypeDescription
                );
                this.createProposalDTO.DefaultProposal.PackageInfo.TransportModeId =
                    primaryPackageLevelEstimate.TransportModeId as number;
                this.proposalService.RefreshTransportDescription(
                    primaryPackageLevelEstimate.TransportModeDescription
                );

                this.createProposalDTO.DefaultProposal.PackageInfo.UOMSystemId =
                    primaryPackageLevelEstimate.UOMSystemId as number;
                this.createProposalDTO.DefaultProposal.PackageInfo.IsFitForAirShipment =
                    true;
                this.filteredHistoryEffectiveFrom = this.createProposalDTO.DefaultProposal.PackageInfo.ProposalEffectivity.History.filter(x => x.Field == 'EffectiveFrom')
                this.filteredHistoryEffectiveTo = this.createProposalDTO.DefaultProposal.PackageInfo.ProposalEffectivity.History.filter(x => x.Field == 'EffectiveTo')
                this.updateControls(this.createProposalDTO);
            }
        });

        this.proposalService.globalUOMOnSubmit.subscribe((uom) => {
            if (uom) {
                if (uom.Id != this.globalUOM.Id) {
                    this.globalUOM = uom;
                    this.updateMeasurements();
                }
            }
        });

        this.proposalService.createProposalDTO.subscribe((prop) => {
            if (prop) {
                this.createProposalDTO = prop;
                this.packageTypeId = this.createProposalDTO.DefaultProposal.PackageInfo.PackageTypeId;
                if (prop
                    && prop.DefaultProposal
                    && prop.DefaultProposal.PackageInfo
                    && prop.DefaultProposal.PackageInfo.ProposalEffectivity
                    && prop.DefaultProposal.PackageInfo.ProposalEffectivity.History) {
                    this.filteredHistoryEffectiveFrom = prop.DefaultProposal.PackageInfo.ProposalEffectivity.History.filter(x => x.Field == 'EffectiveFrom')
                    this.filteredHistoryEffectiveTo = prop.DefaultProposal.PackageInfo.ProposalEffectivity.History.filter(x => x.Field == 'EffectiveTo')
                    console.log(this.filteredHistoryEffectiveFrom);
                }
                
                if (this.isUpdateMode) {
                    this.updateControls(prop);
                } else {
                    this.updatePartInformation(prop);
                    this.logDebug('setting sourceType', prop);
                    this.setSourceTypes(
                        this.partinfoList.map((a) => a.ParentSourceTypeId)
                    );

                    this.refreshGlobalUOMLocally(Constants.IMPERIAL_UOM_ID);
                    this.proposalService.RefreshglobalUOMOnLoad(this.globalUOM);
                }
            }
        });

        this.proposalService.packageTypeMasterList.subscribe((packageTypes) => {
            if (packageTypes) {
                this.packageTypeList = packageTypes;
            }
        });

        this.proposalService.transportModeMasterList.subscribe(
            (transportModes) => {
                if (transportModes) {
                    this.transportModeList = transportModes;
                }
            }
        );

        this.proposalService.sourceTypeMasterList.subscribe((sourceTypes) => {
            if (sourceTypes) {
                this.sourceTypeList = sourceTypes;

                this.setSourceTypes(
                    Array.prototype.map.call(
                        this.createProposalDTO.DefaultProposal.PartInfo.Parts,
                        (s) => s.ParentSourceTypeId
                    )
                );
            }
        });

        (<FormGroup>(
            this.proposalBasicInfoForm.controls['partInfoInProposalForm']
        )).valueChanges.subscribe((data) => {
            this.RefreshFormGroups();
            const partWeight =
                this.partInfoInProposalForm.controls['Weight'].value;
            if (partWeight) {
                this.proposalService.RefreshpartWeightInProposal(partWeight);
            }
            this.formErrorsPartInfoInProposal = this.FormService.validateForm(
                <FormGroup>(
                    this.proposalBasicInfoForm.controls[
                        'partInfoInProposalForm'
                    ]
                ),
                this.formErrorsPartInfoInProposal,
                true,
                true
            );
            this.formUpdated.emit();
        });

        (<FormGroup>(
            this.proposalBasicInfoForm.controls['packageInfoForm']
        )).valueChanges.subscribe((data) => {
            this.formErrorsProposalInfo = this.FormService.validateForm(
                <FormGroup>(
                    this.proposalBasicInfoForm.controls['packageInfoForm']
                ),
                this.formErrorsProposalInfo,
                true,
                true
            );

            this.formUpdated.emit();
        });

      (<FormGroup>(
        this.proposalBasicInfoForm.controls['manufacturingLocationForm']
      )).valueChanges.subscribe((data) => {
        this.formErrorsManufacturingLocation = this.FormService.validateForm(
          <FormGroup>(
            this.proposalBasicInfoForm.controls['manufacturingLocationForm']
          ),
          this.formErrorsManufacturingLocation,
          true,
          true
        );
        this.formUpdated.emit();
      });

      (<FormGroup>(
        this.proposalBasicInfoForm.controls["packageInfoForm"]
      )).controls['EffectiveFrom'].valueChanges.subscribe((data) => {
        
        if(new Date(this.createProposalDTO.DefaultProposal.PackageInfo.ProposalEffectivity.EffectiveFrom).getTime() != new Date(data).getTime()){
            this.effectiveDatesChanged.emit(data);
        }
          
      });

      (<FormGroup>(
        this.proposalBasicInfoForm.controls["packageInfoForm"]
      )).controls['EffectiveTo'].valueChanges.subscribe((data) => {
        if(new Date(this.createProposalDTO.DefaultProposal.PackageInfo.ProposalEffectivity.EffectiveTo).getTime() != new Date(data).getTime()){
            this.effectiveDatesChanged.emit(data);
        }
      });

      (<FormGroup>(
        this.proposalBasicInfoForm.controls['secondaryProcessingLocationForm']
      )).valueChanges.subscribe((data) => {
        if(this.secondaryProcessingLocationEnabled){
          this.formErrorsSecondaryProcessingLocation = this.FormService.validateForm(
            <FormGroup>(
              this.proposalBasicInfoForm.controls['secondaryProcessingLocationForm']
            ),
            this.formErrorsSecondaryProcessingLocation,
            true,
            true
          );
          this.formUpdated.emit();
        }
      });

        this.formReady.emit(this.proposalBasicInfoForm);
        this.setGlobalUOMId();
        this.hardCodeFieldsForUOM();


    }
    // for certain UOMs hardcode weight / length as applicable
    hardCodeFieldsForUOM() {
        var UOMsForHardcodedWeight = ['G', 'KG', 'LB', 'OZ'];
        var UOMsForHardcodedLength = ['MM', 'CM', 'M', 'YD2', 'IN', 'FT'];
        // check for weight type UOM
        if (UOMsForHardcodedWeight.indexOf(this.POUomCode) > -1) {
            const hardcodedWeight = this.getHardCodedUOMValue(this.POUomCode);
            this.partInfoInProposalForm.controls['Weight'].setValue(
                hardcodedWeight
            );
            this.partInfoInProposalForm.controls['Weight'].disable();
        }
        // check for dim (length) type UOM
        if (UOMsForHardcodedLength.indexOf(this.POUomCode) > -1) {
            const hardcodedLength = this.getHardCodedUOMValue(this.POUomCode);
            this.partInfoInProposalForm.controls['Length'].setValue(
                hardcodedLength
            );
            this.partInfoInProposalForm.controls['Length'].disable();
        }
    }
    // Based on current Global UOM (either auto-selected based on location or user selected) and PO UOM return value to be hardcoded
    // example: if PO UOM is M (i.e. meter) and global UOM radio button selection is Imperial (i.e. inches), then return 39.3701 (1 M = 39.3701 inches)
    // it will be of course different formula/ratio for length vs weight
    getHardCodedUOMValue(POUOM: string) {
        if (this.globalUOM.Id == Constants.IMPERIAL_UOM_ID) {
            switch (POUOM) {
                // length
                case 'MM': {
                    return 0.03937;
                    break;
                }
                case 'CM': {
                    return 0.393701;
                    break;
                }
                case 'M': {
                    return 39.3701;
                    break;
                }
                case 'YD2': {
                    return 36;
                    break;
                }
                case 'FT': {
                    return 12;
                    break;
                }
                case 'IN': {
                    return 1;
                    break;
                }
                // weight
                case 'G': {
                    return 0.002204;
                    break;
                }
                case 'KG': {
                    return 2.20462;
                    break;
                }
                case 'LB': {
                    return 1;
                    break;
                }
                case 'OZ': {
                    return 0.0625;
                    break;
                }
            }
        } // Metric
        else {
            switch (POUOM) {
                // length
                case 'MM': {
                    return 1;
                    break;
                }
                case 'CM': {
                    return 10;
                    break;
                }
                case 'M': {
                    return 1000;
                    break;
                }
                case 'FT': {
                    return 304.8;
                    break;
                }
                case 'YD2': {
                    return 914.4;
                    break;
                }
                case 'IN': {
                    return 25.4;
                    break;
                }
                // weight
                case 'G': {
                    return 0.001;
                    break;
                }
                case 'KG': {
                    return 1;
                    break;
                }
                case 'LB': {
                    return 0.453592;
                    break;
                }
                case 'OZ': {
                    return 0.028349;
                    break;
                }
            }
        }
    }
    refreshToolTipText(code: string) {
        this.childControlTooltipText = Constants[code];
    }
    updateMeasurements() {
        // if(this.globalUOM.Id != this.packageLevelUOM.Id)
        if (
            this.dimensionsAndWeightsForSaving.Length ||
            this.dimensionsAndWeightsForSaving.Height ||
            this.dimensionsAndWeightsForSaving.Weight ||
            this.dimensionsAndWeightsForSaving.Width
        ) {
            this.setValuesForConversionOrSaving();
        }
        {
            this.RefreshFormGroups();
            Helper.updateUOMs(
                this.partInfoInProposalForm,
                'Length',
                false,
                this.globalUOM
            );
            Helper.updateUOMs(
                this.partInfoInProposalForm,
                'Width',
                false,
                this.globalUOM
            );
            Helper.updateUOMs(
                this.partInfoInProposalForm,
                'Height',
                false,
                this.globalUOM
            );
            Helper.updateUOMs(
                this.partInfoInProposalForm,
                'Weight',
                true,
                this.globalUOM
            );
            this.convertMesaurementsForSave();
        }
    }

    getDimensionUOMName() {
        if (this.globalUOM) {
            return this.globalUOM.DimensionUoMName;
        } else {
            return '';
        }
    }
    getWeightUOMName() {
        if (this.globalUOM) {
            return this.globalUOM.WeightUoMName;
        } else {
            return '';
        }
    }

    GlobalUOMChanged(event: any) {
        // do changes for self and broadcast
        this.refreshGlobalUOMLocally(event.value);
        this.proposalService.RefreshglobalUOMOnUserToggle(this.globalUOM);
    }

    refreshGlobalUOMLocally(id: number) {
        this.RefreshFormGroups();
        if (this.partInfoInProposalForm) {
            // this.partInfoInProposalForm.controls['globalUOMId'].setValue(id);
            this.globalUOM = Helper.getUoMObject(id);
            this.updateMeasurements();
            this.setBasicInfoValueForDisplay();
        }
    }
    refreshGlobalUOMLocallyOnLoad(id: number) {
        this.RefreshFormGroups();
        if (this.partInfoInProposalForm) {
            this.partInfoInProposalForm.controls['globalUOMId'].setValue(id);
            this.globalUOM = Helper.getUoMObject(id);
            // on page load, if uom for proposal different from default (Imperial), do the adjustments to display
            if (this.globalUOM.Id != Constants.IMPERIAL_UOM_ID) {
                this.updateMeasurements();
            }
        }
    }

    getGlobalUOMId() {
        this.RefreshFormGroups();
        if (this.partInfoInProposalForm) {
            return this.partInfoInProposalForm.controls['globalUOMId'].value;
        } else {
            return Constants.IMPERIAL_UOM_ID;
        }
    }

    updatePartInformation(prop: CreateProposalDTO) {
        const parts = prop.DefaultProposal.PartInfo.Parts;

        this.partNumbers = Array.prototype.map.call(parts, (s) => s.PartNumber);
        if (parts && parts.length > 0) {
            this.POUomCode = parts[0].POUomCode;
            this.partinfoList = parts;
            this.isCriticalPart = parts[0].IsCriticalPart;
        }
    }

    formatDate(date) {
        return Helper.formatDate(date);
    }

    updateProposalLocation(prop: CreateProposalDTO) {
      this.manufacturingLocation = Object.assign(new ProposalLocation(), prop.DefaultProposal.ManufacturingLocation);
      this.secondaryProcessingLocation = Object.assign(new ProposalLocation(), prop.DefaultProposal.SecondaryProcessingLocation);
      this.manufacturingLocation.refresh();
      this.secondaryProcessingLocation.refresh();
    }


    updateControls(prop: CreateProposalDTO) {
        this.RefreshFormGroups();
        // partinfo
        this.updateProposalLocation(prop);
        // this.proposalService.RefreshglobalUOM(Helper.getUoMObject(globalUOMId));
        this.updatePartInformation(prop);
        if (this.partInfoInProposalForm) {
            this.partInfoInProposalForm.patchValue(
                prop.DefaultProposal.PartInfo
            );
        }

        this.packageInfoForm.controls['PackageTypeId'].setValue(
            prop.DefaultProposal.PackageInfo.PackageTypeId
        );
        this.proposalService.RefreshPackageTypeId(
            prop.DefaultProposal.PackageInfo.PackageTypeId
        );
        this.packageInfoForm.controls['TransportModeId'].setValue(
            prop.DefaultProposal.PackageInfo.TransportModeId
        );

        this.proposalService.RefreshTransportModeId(
            prop.DefaultProposal.PackageInfo.TransportModeId
        );

        this.packageInfoForm.controls['EffectiveFrom'].setValue(
            prop.DefaultProposal.PackageInfo.ProposalEffectivity.EffectiveFrom
        );

        this.packageInfoForm.controls['EffectiveTo'].setValue(
            prop.DefaultProposal.PackageInfo.ProposalEffectivity.EffectiveTo
        );

        this.packageInfoForm.controls['IsFitForAirShipment'].setValue(true);
        if (prop.DefaultProposal.ManufacturingLocation.isManual()) {
          this.manualManufacturingLocation = true;
          this.manufacturingLocationForm.controls['ManufacturingManualLocation'].setValue(
            true
          );
        } else {
          this.manualManufacturingLocation = false;
          this.manufacturingLocationForm.controls['ManufacturingManualLocation'].setValue(
            false
          );
        }
      this.manufacturingLocationForm.controls['FullName'].setValue(
        prop.DefaultProposal.ManufacturingLocation.toString()
      );
      this.manufacturingLocationForm.controls['CityName'].setValue(
        prop.DefaultProposal.ManufacturingLocation.CityName
      );
      this.manufacturingLocationForm.controls['StateName'].setValue(
        prop.DefaultProposal.ManufacturingLocation.StateName
      );
      this.manufacturingLocationForm.controls['CountryName'].setValue(
        prop.DefaultProposal.ManufacturingLocation.CountryName
      );
        console.log('manufacturingLocation', prop.DefaultProposal.SecondaryProcessingLocation);
        if(prop.DefaultProposal.SecondaryProcessingLocation.isEmpty()) {
          this.manufacturingLocationForm.controls['SecondaryProcessingEnabled'].setValue(
            false
          );
        }else{
          this.manufacturingLocationForm.controls['SecondaryProcessingEnabled'].setValue(
            true
          );
          this.secondaryProcessingLocationEnabled = true;
          if (prop.DefaultProposal.SecondaryProcessingLocation.isManual()) {
            this.manualSecondaryProcessingLocation = true;
            this.secondaryProcessingLocationForm.controls['SecondaryManualLocation'].setValue(
              true
            );
          } else {
            this.manualSecondaryProcessingLocation = false;
            this.secondaryProcessingLocationForm.controls['SecondaryManualLocation'].setValue(
              false
            );
          }
          this.secondaryProcessingLocationForm.controls['CityName'].setValue(
            prop.DefaultProposal.SecondaryProcessingLocation.CityName
          );
          this.secondaryProcessingLocationForm.controls['StateName'].setValue(
            prop.DefaultProposal.SecondaryProcessingLocation.StateName
          );
          this.secondaryProcessingLocationForm.controls['CountryName'].setValue(
            prop.DefaultProposal.SecondaryProcessingLocation.CountryName
          );
          this.secondaryProcessingLocationForm.controls['FullName'].setValue(
            prop.DefaultProposal.SecondaryProcessingLocation.toString()
          );
        }






        this.globalUOM = Helper.getUoMObject(
            prop.DefaultProposal.PackageInfo.UOMSystemId
        );
        const sourcetypes = [];
        this.createProposalDTO.DefaultProposal.PackageInfo.SourceTypes.forEach(
            (x) => {
                sourcetypes.push(x.SourceTypeId);
            }
        );
        this.setSourceTypes(sourcetypes);
        if (prop.DefaultProposal.PackageInfo.UOMSystemId) {
            const globalUOMId = prop.DefaultProposal.PackageInfo.UOMSystemId;
            this.refreshGlobalUOMLocallyOnLoad(globalUOMId);
            this.proposalService.RefreshglobalUOMOnLoad(
                Helper.getUoMObject(globalUOMId)
            );
            this.logDebug('RefreshglobalUOMOnLoad with', globalUOMId);
            this.convertMesaurementsForSave();
            this.setBasicInfoValueForDisplay();
            this.hardCodeFieldsForUOM();
        }
    }

    RefreshFormGroups() {
        if (this.proposalBasicInfoForm) {
            this.packageInfoForm = <FormGroup>(
                this.proposalBasicInfoForm.controls['packageInfoForm']
            );
            this.partInfoInProposalForm = <FormGroup>(
                this.proposalBasicInfoForm.controls['partInfoInProposalForm']
            );
            this.manufacturingLocationForm = <FormGroup>(
              this.proposalBasicInfoForm.controls['manufacturingLocationForm']
            );
            this.secondaryProcessingLocationForm = <FormGroup>(
              this.proposalBasicInfoForm.controls['secondaryProcessingLocationForm']
            );
        }
    }

    // in case of update this will be called by main proposal component
    // setControlValues(createProposalDTOprop: CreateProposalDTO) {
    //     this.RefreshFormGroups();
    //     const prop = createProposalDTOprop.DefaultProposal;
    //     if (this.packageInfoForm) {
    //         this.packageInfoForm.patchValue(prop.PackageInfo);
    //         this.packageInfoForm.controls['EffectiveFrom'].setValue(
    //             prop.PackageInfo.ProposalEffectivity.EffectiveFrom
    //         );
    //     }
    //     if (this.partInfoInProposalForm) {
    //         this.partInfoInProposalForm.patchValue(prop.PartInfo);
    //     }
    //     this.proposalService.RefreshPackageTypeId(
    //         prop.PackageInfo.PackageTypeId
    //     );
    //     this.proposalService.RefreshTransportModeId(
    //         prop.PackageInfo.TransportModeId
    //     );
    // }

    // setSourceTypes(prop: CreateProposalDTO) {
    //     // select all sourceTypes by default
    //     if(prop && prop.DefaultProposal && prop.DefaultProposal.PackageInfo)
    //     {
    //         const sourceTypeIdsForProp = prop.DefaultProposal.PackageInfo.SourceTypeIds;
    //         const infoForm = <FormGroup>(
    //             this.proposalBasicInfoForm.controls['packageInfoForm']
    //         );
    //         infoForm.controls['SourceTypeIds'].setValue(sourceTypeIdsForProp);
    //         if(this.sourceTypeList && this.sourceTypeList.length > 0 && sourceTypeIdsForProp)
    //         {
    //             this.setSourceTypeDescription(sourceTypeIdsForProp);
    //         }
    //     }
    // }

    setSourceTypes(sourceTypeIds: number[]) {
        if (!sourceTypeIds || sourceTypeIds.length == 0) {
            return;
        }
        // infoForm.controls['SourceTypeIds'].setValue(sourceTypeIds);
        this.MultiplePartsSeleced = sourceTypeIds.length > 1;
        if (
            this.sourceTypeList &&
            this.sourceTypeList.length > 0 &&
            sourceTypeIds
        ) {
            this.setSourceTypeDescription(sourceTypeIds);
        }

        // select all sourceTypes by default
        // if(prop && prop.DefaultProposal && prop.DefaultProposal.PackageInfo)
        // {
        //     const sourceTypeIdsForProp = prop.DefaultProposal.PackageInfo.SourceTypeIds;
        //     const infoForm = <FormGroup>(
        //         this.proposalBasicInfoForm.controls['packageInfoForm']
        //     );
        //     infoForm.controls['SourceTypeIds'].setValue(sourceTypeIdsForProp);
        //     if(this.sourceTypeList && this.sourceTypeList.length > 0 && sourceTypeIdsForProp)
        //     {
        //         this.setSourceTypeDescription(sourceTypeIdsForProp);
        //     }
        // }
    }

    setSourceTypeDescription(sourceTypeIds: number[]) {
        let sourceTypeDescriptions: string = '';
        const infoForm = <FormGroup>(
            this.proposalBasicInfoForm.controls['packageInfoForm']
        );
        if (sourceTypeIds && sourceTypeIds.length > 0) {
            sourceTypeIds.forEach((id) => {
                const loc: SourceType = this.sourceTypeList.find(
                    (a) => a.Id == id
                );
                if (loc !== undefined) {
                    infoForm.controls['SourceTypeId'].setValue(loc.Id);
                    this.proposalService.RefreshSourceTypeId(loc.Id);
                    sourceTypeDescriptions += loc.Description + ', ';
                }
            });
            sourceTypeDescriptions = sourceTypeDescriptions.replace(
                /,\s*$/,
                ''
            );
        }
        this.sourceTypeDescriptions = sourceTypeDescriptions;
        this.proposalService.RefreshSourceTypeDescription(
            sourceTypeDescriptions
        );
    }

    SourceTypesChanged(event: any) {
        this.logDebug('sourceType event', event);
        this.proposalService.RefreshSourceTypeId(event);
    }

    PackageTypeChanged(id: number) {
        this.packageTypeId = id;
        this.proposalService.RefreshPackageTypeId(id);
        const packageTypeDescription = this.packageTypeList.find(
            (a) => a.Id === id
        ).Description;
        this.proposalService.RefreshPackageTypeDescription(
            packageTypeDescription
        );
    }

  secondaryProcessingLocationChanged(id: string | any, propertyType: ProposalPartOriginPropertyId) {
    if (propertyType === ProposalPartOriginPropertyId.Full) {
      this.secondaryProcessingLocation.CountryId = id.Data.CountryId;
      this.secondaryProcessingLocation.CountryName = id.Data.CountryName;
      this.secondaryProcessingLocation.CityId = id.Data.Id;
      this.secondaryProcessingLocation.CityName = id.Data.Name.split(',')[0].trim();
      this.secondaryProcessingLocation.StateId = id.Data.StateId;
      this.secondaryProcessingLocation.StateName = id.Data.StateName;
    }
    if (propertyType === ProposalPartOriginPropertyId.Country) {
      this.secondaryProcessingLocation.CountryId = null;
      this.secondaryProcessingLocation.CountryName = id.target.value;
    }
    if (propertyType === ProposalPartOriginPropertyId.City) {
      this.secondaryProcessingLocation.CityId = null;
      this.secondaryProcessingLocation.CityName = id.target.value;
    }
    if (propertyType === ProposalPartOriginPropertyId.State) {
      this.secondaryProcessingLocation.StateId = null;
      this.secondaryProcessingLocation.StateName = id.target.value;
    }
    this.secondaryProcessingLocation.FullName = this.secondaryProcessingLocation.toString();
    this.secondaryProcessingLocationForm.patchValue({
      CountryName: this.secondaryProcessingLocation.Country.Description,
      StateName: this.secondaryProcessingLocation.State.Description,
      CityName: this.secondaryProcessingLocation.City.Description,
      FullName: this.secondaryProcessingLocation.FullName,
      CityId: this.secondaryProcessingLocation.City.Id,
      StateId: this.secondaryProcessingLocation.State.Id,
      CountryId: this.secondaryProcessingLocation.Country.Id,
    });
    this.proposalService.RefreshSecondaryProcessingLocation(this.secondaryProcessingLocation);
  }



  manufacturingLocationChanged(id: string | any, propertyType: ProposalPartOriginPropertyId) {
      console.log('manufacturingLocationChanged', id, propertyType);
      if (propertyType === ProposalPartOriginPropertyId.Full) {
        this.manufacturingLocation.CountryId = id.Data.CountryId;
        this.manufacturingLocation.CountryName = id.Data.CountryName;
        this.manufacturingLocation.CityId = id.Data.Id;
        this.manufacturingLocation.CityName = id.Data.Name.split(',')[0].trim();
        this.manufacturingLocation.StateId = id.Data.StateId;
        this.manufacturingLocation.StateName = id.Data.StateName;
      }
      if (propertyType === ProposalPartOriginPropertyId.Country) {
        this.manufacturingLocation.CountryId = null;
        this.manufacturingLocation.CountryName = id.target.value;
      }
      if (propertyType === ProposalPartOriginPropertyId.City) {
        this.manufacturingLocation.CityId = null;
        this.manufacturingLocation.CityName = id.target.value;
      }
      if (propertyType === ProposalPartOriginPropertyId.State) {
        this.manufacturingLocation.StateId = null;
        this.manufacturingLocation.StateName = id.target.value;
      }

      this.manufacturingLocation.FullName = this.manufacturingLocation.toString();
      this.manufacturingLocationForm.patchValue({
        CountryName: this.manufacturingLocation.Country.Description,
        StateName: this.manufacturingLocation.State.Description,
        CityName: this.manufacturingLocation.City.Description,
        FullName: this.manufacturingLocation.FullName,
        CityId: this.manufacturingLocation.City.Id,
        CountryId: this.manufacturingLocation.Country.Id,
        StateId: this.manufacturingLocation.State.Id,
      });
      this.proposalService.RefreshManufacturingLocation(this.manufacturingLocation);
    }




    @ViewChild('CityAutoComplete') CityAutoComplete: TeslaAutocompleteComponent;
    @ViewChild('CityAutoComplete1') CityAutoComplete1: TeslaAutocompleteComponent;
    onEmptyCity(eventObj: any): void {
      this.CityAutoComplete.list = [];
    }


    disableSourceTypeList() {
        return this.IsSupplier;
        // return true; //TMS-4435:  disable in any case
    }

    TransportModeChanged(id: number) {
        this.proposalService.RefreshTransportModeId(id);
        const transportModeDescription = this.transportModeList.find(
            (a) => a.Id == id
        ).Description;
        this.proposalService.RefreshTransportDescription(
            transportModeDescription
        );
    }

    onFilterChange() {}

    ValidateForm(IsForSubmit: boolean = true) {
        this.RefreshFormGroups();

        if(!this.secondaryProcessingLocationEnabled){
          if(IsForSubmit){
            this.secondaryProcessingLocationForm.reset();
          }
          this.secondaryProcessingLocationForm.get('CityName').clearValidators();
          this.secondaryProcessingLocationForm.get('FullName').clearValidators();
          this.secondaryProcessingLocationForm.get('CountryName').clearValidators();
          this.secondaryProcessingLocationForm.get('CityName').updateValueAndValidity();
          this.secondaryProcessingLocationForm.get('FullName').updateValueAndValidity();
          this.secondaryProcessingLocationForm.get('CountryName').updateValueAndValidity();
        }
        this.partInfoInProposalForm.controls['Length'].setErrors(null);
        this.partInfoInProposalForm.controls['Width'].setErrors(null);
        this.partInfoInProposalForm.controls['Height'].setErrors(null);
        this.partInfoInProposalForm.controls['Weight'].setErrors(null);


        this.formErrorsManufacturingLocation = this.FormService.validateForm(
          <FormGroup>this.proposalBasicInfoForm.controls['manufacturingLocationForm'],
          this.formErrorsManufacturingLocation
        );

        if(this.secondaryProcessingLocationEnabled){
          this.formErrorsSecondaryProcessingLocation = this.FormService.validateForm(
            <FormGroup>this.proposalBasicInfoForm.controls['secondaryProcessingLocationForm'],
            this.formErrorsSecondaryProcessingLocation
          );
        }

        if (!this.packageInfoForm.controls['EffectiveFrom'].value) {
            this.packageInfoForm.controls['EffectiveFrom'].setErrors({
                required: true,
            });
        } else {
            /**
             * TMS-15424 Remove ability to backdate proposals
             * Users should not be able to provide an effective start date which is in the past.
             * The earliest Effective start date can be today + 1 day.
             */
            let currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);
            // TMS-17191 Create a Date instance with EffectiveFrom form controller for validation
            const effectiveFromDate = new Date(
                this.packageInfoForm.controls['EffectiveFrom'].value
            );
            if (
                !Helper.validateEffectiveFromDate(
                    effectiveFromDate,
                    Helper.addDays(currentDate, 1)
                )
            ) {
                this.packageInfoForm.controls['EffectiveFrom'].setErrors({
                    invalidEffectiveFromDate: true,
                });
            }
        }

        // set validators real time based on save operation for draft or submit
        //tms-33351 allow weight upto 6 decimal places
        if (IsForSubmit) {
            this.partInfoInProposalForm.controls['Length'].setValidators([
                Validators.required,
                Validators.min(0.00001),
                Validators.pattern('[0-9]*(.[0-9]{1,8})?'),
            ]);
            this.partInfoInProposalForm.controls['Width'].setValidators([
                Validators.required,
                Validators.min(0.00001),
                Validators.pattern('[0-9]*(.[0-9]{1,8})?'),
            ]);
            this.partInfoInProposalForm.controls['Height'].setValidators([
                Validators.required,
                Validators.min(0.00001),
                Validators.pattern('[0-9]*(.[0-9]{1,8})?'),
            ]);
            this.partInfoInProposalForm.controls['Weight'].setValidators([
                Validators.required,
                Validators.min(0.000001),
                Validators.pattern('[0-9]*(.[0-9]{1,8})?'),
            ]);
            this.partInfoInProposalForm.controls[
                'Length'
            ].updateValueAndValidity({ emitEvent: false, onlySelf: false });
            this.partInfoInProposalForm.controls[
                'Width'
            ].updateValueAndValidity({ emitEvent: false, onlySelf: false });
            this.partInfoInProposalForm.controls[
                'Height'
            ].updateValueAndValidity({ emitEvent: false, onlySelf: false });
            this.partInfoInProposalForm.controls[
                'Weight'
            ].updateValueAndValidity({ emitEvent: false, onlySelf: false });
        }
        this.formUpdated.emit();
        this.formErrorsPartInfoInProposal = this.FormService.validateForm(
            <FormGroup>(
                this.proposalBasicInfoForm.controls['partInfoInProposalForm']
            ),
            this.formErrorsPartInfoInProposal,
            null,
            !IsForSubmit
        );
        this.formErrorsProposalInfo = this.FormService.validateForm(
            <FormGroup>this.proposalBasicInfoForm.controls['packageInfoForm'],
            this.formErrorsProposalInfo
        );

        // if(!this.isUpdateMode)
        // {
        //     let effectiveFromErrorObj = ValidateEffectivityFrom(<FormControl>this.packageInfoForm.controls['EffectiveFrom']);
        //     this.packageInfoForm.controls[
        //         'EffectiveFrom'
        //     ].setErrors(effectiveFromErrorObj);
        // }
    }

    setBasicInfoValueForDisplay() {
        Helper.convertValueForDisplay(
            this.partInfoInProposalForm,
            this.dimensionsAndWeightsForSaving
        );
    }
  searchCityURL: string;
    convertMesaurementsForSave() {
        this.dimensionsAndWeightsForSaving.Height =
            this.partInfoInProposalForm.controls['Height'].value;
        this.dimensionsAndWeightsForSaving.Length =
            this.partInfoInProposalForm.controls['Length'].value;
        this.dimensionsAndWeightsForSaving.Width =
            this.partInfoInProposalForm.controls['Width'].value;
        this.dimensionsAndWeightsForSaving.Weight =
            this.partInfoInProposalForm.controls['Weight'].value;
    }

    setValuesForConversionOrSaving() {
        Helper.setValuesInForm(
            this.partInfoInProposalForm,
            this.dimensionsAndWeightsForSaving
        );
    }

    //tms-31085 toogle radio button to metric units for locations outside US

    setGlobalUOMId() {
        const sourcetypeID =
            this.createProposalDTO.DefaultProposal.PartInfo.Parts.map(
                (x) => x.ParentSourceTypeId
            );
        var filteredLocation = Constants.LOCATIONS_FOR_METRIC_UOM_ID.filter(
            (x) => sourcetypeID.includes(x)
        );
        if (filteredLocation.length > 0) {
            this.partInfoInProposalForm.controls['globalUOMId'].setValue(
                Constants.METRIC_UOM_ID
            );
            this.refreshGlobalUOMLocally(Constants.METRIC_UOM_ID);
            this.proposalService.RefreshglobalUOMOnLoad(this.globalUOM);
        }
    }
}
